import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useState } from 'react';
import styles from './Input.module.scss';
import infoIcon from '../../../assets/Imagess/pending.svg';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
const TextInput = ({
  label,
  required,
  width,
  value,
  onChange,
  name,
  errors,
  touched,
  type,
  disabled,
  icon,
  placeholder,
  text,
  grey,
  disabledInputOnly = false,
  titleColor = '',
  inputColor = '',
  borderColor = '',
  inputBackground = '',
  specialClassName = '',
  left,
  containerStyle,
  onlyValue,
  labelColor,
  info,
}) => {
  const [initialValue, setInitialValue] = useState(value);

  const handleChange = (event) => {
    const newValue = DOMPurify.sanitize(event.target.value);
    setInitialValue(newValue);
    if (onChange) {
      onChange(name, newValue);
    }
  };

  const inputStyle = {
    width: width,
    borderColor:
      errors && touched
        ? '#F3223C'
        : grey || disabled
        ? '#0003b'
        : borderColor
        ? borderColor
        : '#000',
    direction: left ? 'rtl' : '',
  };

  useEffect(() => {
    setInitialValue(value);
  }, [value]);

  return (
    <div className={styles['textBox-container']} style={containerStyle}>
      <label
        htmlFor={label}
        style={{
          color: labelColor,
          opacity: disabled ? '0.5' : '1',
          direction: left ? 'rtl' : '',
        }}
      >
        {label}
        {required && <span className={styles['required']}>*</span>}
      </label>

      <div className={styles['icon-input-container']} style={inputStyle}>
        {icon && <img src={icon} alt='icon' className={styles['icon']} />}
        <input
          type={type ? type : 'text'}
          id={label}
          required={required}
          placeholder={placeholder}
          className={`${styles['text-input']} ${styles[specialClassName]}`}
          onChange={text ? onChange : handleChange}
          value={text ? value : onlyValue ? value : initialValue}
          disabled={disabled ? true : disabledInputOnly ? true : false}
          style={{
            color: inputColor && inputColor,
            backgroundColor: inputBackground && inputBackground,
          }}
        />
        {info && (
          <Tippy content={info}>
            <img
              src={infoIcon}
              alt='info'
              style={{ paddingLeft: '5px', paddingTop: '5px', height: '25px' }}
            />
          </Tippy>
        )}
      </div>
    </div>
  );
};

export default TextInput;
